// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"292":"f1e90881","453":"6453d4b6"}[chunkId] + ".chunk.js";
};